<template>
  <div>
    <div class="p-2 embed-responsive embed-responsive-16by9" >
      <iframe class="embed-responsive-item" :src="mediaObject.url"></iframe>
    </div>
    <div class="text-center">
      <a :href="mediaObject.url" target="_blank">Open in new tab</a>
    </div>
  </div>
</template>

<script>
import ExternalMediaObject from './ExternalMediaObject'
export default {
  name: 'WordPressObject',
  mixins: [ExternalMediaObject]
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/socialMedia/WordPressObject.vue